import './Stepper.scss';
import { Stepper, Step, StepLabel } from '@mui/material';
import StepConnector from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { useCartStore } from 'stores/Webshop/CartStore';

type Props = {
  activeStep: number;
  handleActiveStep: (step: number) => void;
};

export const CartStepper = ({ activeStep, handleActiveStep }: Props) => {
  const agreedToTermsAndConditions = useCartStore((state) => state.agreedToTermsAndConditions);
  const shouldDisableFirstStep = activeStep === 2;
  const shouldDisableSecondStep = (activeStep === 0 && !agreedToTermsAndConditions) || activeStep === 2;

  return (
    <Stepper className='cart-stepper' activeStep={activeStep} alternativeLabel connector={<StepConnector />}>
      <Step disabled={shouldDisableFirstStep} onClick={() => (shouldDisableFirstStep ? null : handleActiveStep(0))}>
        <StepLabel StepIconComponent={StepIcon}>Cart</StepLabel>
      </Step>
      <Step disabled={shouldDisableSecondStep} onClick={() => (shouldDisableSecondStep ? null : handleActiveStep(1))}>
        <StepLabel StepIconComponent={StepIcon}>Payment</StepLabel>
      </Step>
      <Step disabled={activeStep < 2} onClick={() => handleActiveStep(2)}>
        <StepLabel StepIconComponent={StepIcon}>Confirmation</StepLabel>
      </Step>
    </Stepper>
  );
};

const StepIcon = (stepIconProps: StepIconProps) => {
  return <div className='stepper-icon'>{stepIconProps.icon}</div>;
};
